export default __webpack_public_path__ + "static/media/premio_bg_modal.b1e3f50d.png";